import PropTypes from 'prop-types';
import React, { useContext, useEffect } from 'react';
import { graphql, Link } from 'gatsby';
import { ThemeContext } from '../layouts/Layout';
import { removeDuplicates, sortCombinedAllPosts } from '../utils/helpers';
import ScrollTo, { scrollToContent } from '../components/Common/scroll-to';
import Blog from '../components/Blog';
import Hero from '../components/Hero';
import Seo from '../components/Seo';
import config from '../../content/meta/meta-config';
// import GoogleAd from '../components/Ad'; //auto ad already place quite a few ads on the index page
import { CgArrowLeftR } from '@react-icons/all-files/cg/CgArrowLeftR';
import { CgArrowRightR } from '@react-icons/all-files/cg/CgArrowRightR';
import { CgArrowUpR } from '@react-icons/all-files/cg/CgArrowUpR';
import { MdRestaurant } from '@react-icons/all-files/md/MdRestaurant';
import { FaRegPaperPlane } from '@react-icons/all-files/fa/FaRegPaperPlane';
import { FaSuitcaseRolling } from '@react-icons/all-files/fa/FaSuitcaseRolling';
import { IoIosAirplane } from '@react-icons/all-files/io/IoIosAirplane';
import { RiCake3Line } from '@react-icons/all-files/ri/RiCake3Line';
import { RiHotelLine } from '@react-icons/all-files/ri/RiHotelLine';
import { styled } from '@linaria/react';
import { css } from '@linaria/core';

// const separator = React.createRef();

// const scrollToContent = (e) => {
//   separator.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
// };

const IndexPage = (props) => {
  const { currentPage, numPages } = props.pageContext;
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage === numPages;
  const prevPage = currentPage - 1 === 1 ? '/' : `/${currentPage - 1}`;
  const nextPage = `/${currentPage + 1}`;
  const currentPagePath = currentPage - 1 === 0 ? '' : `/${currentPage}`;
  const {
    data: {
      markdownPosts: { edges: markdownPosts = [] },
      contentfulPosts: { edges: contentfulPosts = [] },
      featuresHighlightsPosts: { edges: featuresHighlightsPosts = [] },
      latestTravelMarkdownPosts: { edges: latestTravelMarkdownPosts = [] },
      latestTravelContentfulPosts: { edges: latestTravelContentfulPosts = [] },
      hotelUnboxMarkdownPosts: { edges: hotelUnboxMarkdownPosts = [] },
      hotelUnboxContentfulPosts: { edges: hotelUnboxContentfulPosts = [] },
      latestLazyPackMarkdownPosts: { edges: latestLazyPackMarkdownPosts = [] },
      latestLazyPackContentfulPosts: { edges: latestLazyPackContentfulPosts = [] },
      latestFoodMarkdownPosts: { edges: latestFoodMarkdownPosts = [] },
      latestFoodContentfulPosts: { edges: latestFoodContentfulPosts = [] },
      heroImageBg4K: {
        resize: { src: heroBgFourK },
      },
      heroImageBgQHD: {
        resize: { src: heroBgQHD },
      },
      heroImageBgDesktop: {
        resize: { src: heroBgDesktop },
      },
      heroImageBgTablet: {
        resize: { src: heroBgTablet },
      },
      heroImageBgMobile: {
        resize: { src: heroBgMobile },
      },
      site: {
        siteMetadata: { facebook },
      },
    },
  } = props;
  // Combine both markdown posts and contentful posts
  let allPosts = [...markdownPosts, ...contentfulPosts];
  let allLatestTravelPosts = [...latestTravelMarkdownPosts, ...latestTravelContentfulPosts];
  let allHotelUnboxPosts = [...hotelUnboxMarkdownPosts, ...hotelUnboxContentfulPosts];
  let allLatestLazyPackPosts = [...latestLazyPackMarkdownPosts, ...latestLazyPackContentfulPosts];
  let allLatestFoodPosts = [...latestFoodMarkdownPosts, ...latestFoodContentfulPosts];
  sortCombinedAllPosts(allPosts);
  sortCombinedAllPosts(allLatestTravelPosts);
  sortCombinedAllPosts(allHotelUnboxPosts);
  sortCombinedAllPosts(allLatestLazyPackPosts);
  sortCombinedAllPosts(allLatestFoodPosts);
  allPosts = allPosts.slice(0, 12); //limit to just at most 12 posts
  allLatestTravelPosts = allLatestTravelPosts.slice(0, 3); //limit to just 3 posts
  allHotelUnboxPosts = allHotelUnboxPosts.slice(0, 3); //limit to just 3 posts
  allLatestLazyPackPosts = allLatestLazyPackPosts.slice(0, 3); //limit to just 3 posts
  allLatestFoodPosts = allLatestFoodPosts.slice(0, 3); //limit to just 3 posts

  // const screenWidth = getScreenWidth();
  // console.log('screenWidth', screenWidth);
  // Pixel 3 will change JS screen.width to 786px when change to landscape used 540px as threshold to reduce wide
  // use width 455px for width wider than 540px
  // const fbPagePluginWidth = screenWidth <= 540 ? 340 : 455;
  const fbPagePluginWidth = 340;
  const fbPluginURL = `https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FFabulousRecipe&tabs&width=${fbPagePluginWidth}&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=2346850212265897`;
  const heroBackgrounds = {
    heroBgFourK,
    heroBgQHD,
    heroBgDesktop,
    heroBgTablet,
    heroBgMobile,
  };

  // can only have one post type (travel or food or other type) for item list
  let seoItemList = [
    ...featuresHighlightsPosts,
    ...allLatestTravelPosts,
    ...allHotelUnboxPosts,
    ...allLatestLazyPackPosts,
    ...allLatestFoodPosts,
    ...allPosts,
  ].map((post) => config.siteUrl + (post.node?.fields?.slug ? post.node.fields.slug : post.node?.slug + '/'));
  seoItemList = removeDuplicates(seoItemList);
  // console.debug('index seoItemList', seoItemList);
  const currentPageTitle = currentPage - 1 === 0 ? '首頁' : `首頁 近期分享之${currentPage}`;

  const seoData = {
    indexUrl: `https://thefabulouslifestyles.com${currentPagePath}`,
    seoItemList,
    frontmatter: {
      title: currentPageTitle,
    },
  };

  // useEffect(() => {
  //   console.log(`useEffect index template mount`);
  //   // console.log(`useEffect index template mount: ${JSON.stringify(props, null, 4)}`);
  //   return () => {
  //     console.log(`useEffect index template unmount`);
  //     // console.log(`useEffect index template unmount: ${JSON.stringify(props, null, 4)}`);
  //   };
  // }, []);

  // const likeButtonURL = `https://button.like.co/in/embed/fabulous-lifestyles/button?referrer=${joinPath(
  //   config.siteUrl,
  //   currentPagePath
  // )}/`;

  return (
    <React.Fragment>
      {isFirstPage && (
        <ThemeContext.Consumer>
          {(theme) => (
            <Hero
              scrollToContent={scrollToContent}
              backgrounds={heroBackgrounds}
              theme={theme}
              headerTitle={config.headerTitle}
              headerSubTitle={config.headerSubTitle}
              category="旅行日誌"
              // heroCaption="佛羅倫斯主教座堂 - 佛羅倫斯．義大利"
              // heroCaptionEx="Florence Cathedral - Florence, Italy"
            />
          )}
        </ThemeContext.Consumer>
      )}

      {/* <SeparatorStyled className={isFirstPage ? 'isFirstPage' : ''} ref={separator} /> */}
      <ScrollTo isFirstPage={isFirstPage} isHr={false} />
      {/* Display section with feature hightlights */}
      {isFirstPage && (
        <ThemeContext.Consumer>
          {(theme) => (
            <Blog
              posts={featuresHighlightsPosts}
              category=""
              theme={theme}
              isAtTop={true}
              isFeatured={true}
              isFirstPage={isFirstPage}
            />
          )}
        </ThemeContext.Consumer>
      )}
      {isFirstPage && (
        <>
          <section className={linkForMoreArticleSection}>
            <h2 className={linkForMoreIcon}>
              <FaRegPaperPlane size={25} />
            </h2>
            <div className={linkForMoreText}>還有哪些熱門的旅遊地點？下面有更多的熱門文章分享</div>
            <h2 className={linkForMoreIcon}>
              <FaRegPaperPlane size={25} />
            </h2>
          </section>
          <div style={{ textAlign: 'center' }}>
            <iframe
              loading="lazy"
              src={fbPluginURL}
              width={fbPagePluginWidth}
              height="130"
              style={{ border: 'none', overflow: 'hidden' }}
              scrolling="no"
              frameBorder="0"
              allowtransparency="true"
              allow="encrypted-media"
            />
          </div>
        </>
      )}
      {/* For each category - display couple latest posts */}
      {isFirstPage && (
        <ThemeContext.Consumer>
          {(theme) => (
            <React.Fragment>
              <Blog
                posts={allHotelUnboxPosts}
                category="旅行日誌"
                isFocusPosts={true}
                theme={theme}
                isAtTop={false}
                subCategory="飯店開箱系列"
              />
              <section className={linkForMoreArticleSection}>
                <h2 className={linkForMoreIcon}>
                  <RiHotelLine size={25} />
                </h2>
                <Link to="/tags/飯店開箱/" style={{ color: 'var(--textTitleLink)', fontSize: '1.2em' }}>
                  更多的飯店開箱系列分享
                </Link>
                <h2 className={linkForMoreIcon}>
                  <RiHotelLine size={25} />
                </h2>
              </section>
              <Blog
                posts={allLatestTravelPosts}
                category="旅行日誌"
                theme={theme}
                isFocusPosts={true}
                isFocusLastPost={true}
                isAtTop={false}
              />
              <section className={linkForMoreArticleSection}>
                <h2 className={linkForMoreIcon}>
                  <IoIosAirplane size={25} />
                </h2>
                <Link to="/travel/" style={{ color: 'var(--textTitleLink)', fontSize: '1.2em' }}>
                  更多的熱門旅遊系列分享
                </Link>
                <h2 className={linkForMoreIcon}>
                  <IoIosAirplane size={25} />
                </h2>
              </section>
              <Blog
                posts={allLatestLazyPackPosts}
                category="旅行日誌"
                theme={theme}
                isFocusPosts={true}
                isAtTop={false}
                subCategory="熱門懶人包系列"
              />
              <section className={linkForMoreArticleSection}>
                <h2 className={linkForMoreIcon}>
                  <FaSuitcaseRolling size={25} />
                </h2>
                <Link to="/tags/懶人包/" style={{ color: 'var(--textTitleLink)', fontSize: '1.2em' }}>
                  更多的懶人包系列分享
                </Link>
                <h2 className={linkForMoreIcon}>
                  <FaSuitcaseRolling size={25} />
                </h2>
              </section>
              {/* <LikecoinButton className="likecoin-embed likecoin-button">
                <iframe
                  loading="lazy"
                  scrolling="no"
                  frameBorder="0"
                  sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                  style={{ height: '212px', width: '100%', overflow: 'hidden' }}
                  src={likeButtonURL}
                ></iframe>
              </LikecoinButton> */}
              <Blog
                posts={allLatestFoodPosts}
                category="美味廚房"
                theme={theme}
                isFocusPosts={true}
                isFocusLastPost={true}
              />
              <section className={linkForMoreArticleSection}>
                <h2 className={linkForMoreIcon}>
                  <RiCake3Line size={25} />
                </h2>
                <Link to="/food/" style={{ color: 'var(--textTitleLink)', fontSize: '1.2em' }}>
                  更多的美味廚房食譜分享
                </Link>
                <h2 className={linkForMoreIcon}>
                  <RiCake3Line size={25} />
                </h2>
              </section>
            </React.Fragment>
          )}
        </ThemeContext.Consumer>
      )}

      <ThemeContext.Consumer>
        {(theme) => (
          <Blog
            posts={allPosts}
            category="近期分享"
            theme={theme}
            isFocusPosts={false}
            isAtTop={!isFirstPage}
          />
        )}
      </ThemeContext.Consumer>
      <section className="{adSection}">
        {/* <LikecoinButton className="likecoin-embed likecoin-button">
          <iframe
            loading="lazy"
            scrolling="no"
            frameBorder="0"
            sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
            style={{ height: '212px', width: '100%', overflow: 'hidden' }}
            src={likeButtonURL}
          ></iframe>
        </LikecoinButton> */}
        <div style={{ textAlign: 'center' }}>
          <iframe
            loading="lazy"
            src={fbPluginURL}
            width={fbPagePluginWidth}
            height="130"
            style={{ border: 'none', overflow: 'hidden' }}
            scrolling="no"
            frameBorder="0"
            allowtransparency="true"
            allow="encrypted-media"
          />
        </div>
      </section>
      <PaginationUnorderedList>
        {!isFirstPage && (
          <Link to={prevPage} rel="prev" style={{ display: 'flex', fontSize: '1.4em' }}>
            <CgArrowLeftR size={24} style={{ margin: '0 0.5em', alignSelf: 'center' }} /> 近期文章{' '}
            <FaRegPaperPlane style={{ margin: '0 0.5em', alignSelf: 'center' }} />
          </Link>
        )}
        {/*Array.from({ length: numPages }, (_, i) => {
          if (i + 1 !== currentPage) {
            return (
              <li key={`pagination-number${i + 1}`}>
                <Link to={`/${i === 0 ? '' : i + 1}`} style={{ padding: '0 1em' }}>
                  {i + 1}
                </Link>
              </li>
            );
          } else {
            // The current page index does not provide a link to the page
            return (
              <li key={`pagination-number${i + 1}`} className="current-page-link">
                {i + 1}
              </li>
            );
          }
        })*/}
        {/* {!isLastPage && (
          <Link to={nextPage} rel="next" style={{ display: 'flex', fontSize: '1.4em' }}>
            <MdRestaurant size={24} style={{ margin: '0 0.5em', alignSelf: 'center' }} /> 更多文章
            <CgArrowRightR size={24} style={{ margin: '0 0.5em', alignSelf: 'center' }} />
          </Link>
        )} */}

        <Link to="/new/" rel="next" style={{ display: 'flex', fontSize: '1.4em' }}>
          <FaRegPaperPlane size={24} style={{ margin: '0 0.5em', alignSelf: 'center' }} /> 更多文章
          <CgArrowRightR size={24} style={{ margin: '0 0.5em', alignSelf: 'center' }} />
        </Link>

        <li className="top-page-link" onClick={scrollToContent}>
          <CgArrowUpR size={24} style={{ marginRight: '0.5em', alignSelf: 'center' }} /> 回到最上
          <CgArrowUpR size={24} style={{ marginLeft: '0.5em', alignSelf: 'center' }} />
        </li>
      </PaginationUnorderedList>
      <Seo data={seoData} facebook={facebook} />
    </React.Fragment>
  );
};
IndexPage.propTypes = {
  data: PropTypes.object.isRequired,
  pageContext: PropTypes.object.isRequired,
};

export default React.memo(IndexPage);

const PaginationUnorderedList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-items: center;
  list-style: none;
  padding: 0;
  margin-top: 50px;

  .current-page-link {
    background: coral;
    color: white;
    border-radius: 25%;
    padding: 5px 10px;
    margin-left: 1em;
  }

  .top-page-link {
    cursor: alias;
    color: var(--textTitleLink);
    margin: 1em;
    padding: 0 1em;
    display: flex;
    font-size: 1.4em;
  }
`;

const adSection = css`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
`;

const linkForMoreArticleSection = css`
  display: flex;
  margin: 2em 1em;
  justify-content: space-evenly;
`;

const linkForMoreIcon = css`
  align-self: center;
  color: var(--svg-dark-mode-icon-stroke);
`;

const linkForMoreText = css`
  color: var(--textTitleLink);
  font-size: 1.2em;
  text-align: center;

  @media (max-width: 680px) {
    flex-basis: 70%;
  }
`;

const SeparatorStyled = styled.div`
  @media (min-width: 980px) {
    &.isFirstPage {
      margin-top: 10px;
    }
  }
`;
/* const LikecoinButton = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 485px;
  max-height: 240px;

  & > div {
    padding-top: 49.48454%;
  }
  & > iframe {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`; */

//eslint-disable-next-line no-undef
export const query = graphql`
  query IndexQuery($skip: Int!, $limit: Int!) {
    # 近期分享 limit to only show 6 markdown posts on the main index page
    # query posts from all categories
    markdownPosts: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "//posts/[0-9]+.*--/" }, frontmatter: { newpost: { ne: true } } }
      sort: { frontmatter: { datePublished: DESC } }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            category
            tags
            author
            newpost
            cover {
              # used to display the blog items picture for each post on travel index page
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, transformOptions: { cropFocus: CENTER })
              }
            }
          }
        }
      }
    }
    contentfulPosts: allContentfulPost(
      limit: $limit
      skip: $skip
      sort: { datePublished: DESC }
      filter: { newpost: { ne: true } }
    ) {
      edges {
        node {
          title
          author
          datePublished
          slug
          newpost
          tags
          category
          contentful_id
          excerpt {
            excerpt
          }
          imageCoverHero {
            gatsbyImageData(layout: CONSTRAINED, aspectRatio: 1.6, formats: [AUTO, AVIF, WEBP])
          }
        }
      }
    }
    featuresHighlightsPosts: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "//features-highlights/" }
        frontmatter: { category: { eq: "features-highlight" } }
      }
      sort: { frontmatter: { featureIndex: ASC } }
      limit: 3
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
          }
          frontmatter {
            title
            category
            tags
            feature
            cover {
              # used to display the blog items picture for each post on travel index page
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, transformOptions: { cropFocus: CENTER })
              }
            }
          }
        }
      }
    }
    latestTravelMarkdownPosts: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "//posts/[0-9]+.*--/" }
        frontmatter: { category: { eq: "旅行日誌" }, newpost: { eq: true } }
      }
      sort: { frontmatter: { datePublished: DESC } }
      limit: 3
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            category
            tags
            author
            cover {
              # used to display the blog items picture for each post on travel index page
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  transformOptions: { cropFocus: CENTER }
                  aspectRatio: 1.6
                )
              }
            }
          }
        }
      }
    }
    latestTravelContentfulPosts: allContentfulPost(
      limit: 3
      sort: { datePublished: DESC }
      filter: { category: { eq: "旅行日誌" }, newpost: { eq: true } }
    ) {
      edges {
        node {
          title
          author
          datePublished
          slug
          newpost
          tags
          category
          contentful_id
          excerpt {
            excerpt
          }
          imageCoverHero {
            gatsbyImageData(layout: CONSTRAINED, aspectRatio: 1.6, formats: [AUTO, AVIF, WEBP])
          }
        }
      }
    }
    hotelUnboxMarkdownPosts: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "//posts/[0-9]+.*--/" }
        frontmatter: { category: { eq: "旅行日誌" }, tags: { in: ["飯店開箱"] } }
      }
      sort: { frontmatter: { datePublished: DESC } }
      limit: 3
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            category
            tags
            author
            cover {
              # used to display the blog items picture for each post on travel index page
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  transformOptions: { cropFocus: CENTER }
                  aspectRatio: 1.6
                )
              }
            }
          }
        }
      }
    }
    hotelUnboxContentfulPosts: allContentfulPost(
      limit: 3
      sort: { datePublished: DESC }
      filter: { category: { eq: "旅行日誌" }, tags: { in: ["飯店開箱"] } }
    ) {
      edges {
        node {
          title
          author
          datePublished
          slug
          newpost
          tags
          category
          contentful_id
          excerpt {
            excerpt
          }
          imageCoverHero {
            gatsbyImageData(layout: CONSTRAINED, aspectRatio: 1.6, formats: [AUTO, AVIF, WEBP])
          }
        }
      }
    }
    latestLazyPackMarkdownPosts: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "//posts/[0-9]+.*--/" }
        frontmatter: { category: { eq: "旅行日誌" }, tags: { in: ["懶人包"] } }
      }
      sort: { frontmatter: { datePublished: DESC } }
      limit: 3
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            category
            tags
            author
            cover {
              # used to display the blog items picture for each post on travel index page
              childImageSharp {
                gatsbyImageData(
                  layout: CONSTRAINED
                  transformOptions: { cropFocus: CENTER }
                  aspectRatio: 1.6
                )
              }
            }
          }
        }
      }
    }
    latestLazyPackContentfulPosts: allContentfulPost(
      limit: 3
      sort: { datePublished: DESC }
      filter: { category: { eq: "旅行日誌" }, tags: { in: ["懶人包"] } }
    ) {
      edges {
        node {
          title
          author
          datePublished
          slug
          newpost
          tags
          category
          contentful_id
          excerpt {
            excerpt
          }
          imageCoverHero {
            gatsbyImageData(layout: CONSTRAINED, aspectRatio: 1.6, formats: [AUTO, AVIF, WEBP])
          }
        }
      }
    }
    latestFoodMarkdownPosts: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "//posts/[0-9]+.*--/" }
        frontmatter: { category: { eq: "美味廚房" }, newpost: { eq: true } }
      }
      sort: { frontmatter: { datePublished: DESC } }
      limit: 3
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
            prefix
          }
          frontmatter {
            title
            category
            tags
            author
            cover {
              # used to display the blog items picture for each post on travel index page
              childImageSharp {
                gatsbyImageData(layout: CONSTRAINED, transformOptions: { cropFocus: CENTER })
              }
            }
          }
        }
      }
    }
    latestFoodContentfulPosts: allContentfulPost(
      limit: 3
      sort: { datePublished: DESC }
      filter: { category: { eq: "美味廚房" }, newpost: { eq: true } }
    ) {
      edges {
        node {
          title
          author
          datePublished
          slug
          newpost
          tags
          category
          contentful_id
          excerpt {
            excerpt
          }
          imageCoverHero {
            gatsbyImageData(layout: CONSTRAINED, aspectRatio: 1.6, formats: [AUTO, AVIF, WEBP])
          }
        }
      }
    }
    site {
      siteMetadata {
        facebook {
          appId
        }
      }
    }
    heroImageBg4K: imageSharp(fluid: { originalName: { regex: "/hero-background/" } }) {
      # for 2560 4K use higher resolution image
      resize(width: 3840, quality: 70, cropFocus: CENTER) {
        src
      }
    }
    heroImageBgQHD: imageSharp(fluid: { originalName: { regex: "/hero-background/" } }) {
      # for 1800 QHD use higher resolution image
      resize(width: 2560, quality: 70, cropFocus: CENTER) {
        src
      }
    }
    heroImageBgDesktop: imageSharp(fluid: { originalName: { regex: "/hero-background/" } }) {
      resize(width: 1440, quality: 70, cropFocus: CENTER) {
        src
      }
    }
    heroImageBgTablet: imageSharp(fluid: { originalName: { regex: "/hero-mobile-background/" } }) {
      resize(width: 1440, quality: 70, cropFocus: CENTER) {
        src
      }
    }
    heroImageBgMobile: imageSharp(fluid: { originalName: { regex: "/hero-mobile-background/" } }) {
      resize(width: 450, height: 850, quality: 70, cropFocus: CENTER) {
        src
      }
    }
  }
`;

//hero-background
